import ContentArea from 'components/content-area/ContentArea';
import ContentContainer from 'components/content-container/ContentContainer';
import FrontpageHeader from 'components/frontpage-header/FrontpageHeader';
import LinkList from 'components/link-list/LinkList';

import { ContentAreaItem_Size, IFrontpage } from 'source/NFR.types';

const narrowTextProps = {
  HtmlString: { theme: 'narrow' }
};

const Frontpage: React.FC<IFrontpage> = ({ content, header, linkList }) => (
  <div className="frontpage">
    {header && <FrontpageHeader {...header} />}
    {linkList && <LinkList className="frontpage--link-list" {...linkList} theme="frontpageLinks" withIcon />}
    <ContentContainer className="frontpage--content">
      <ContentArea
        additionalComponentProps={{
          ...narrowTextProps,
          // NOTE: RichText is just a proxy for ContentArea, so themes need to be applied using additionalComponentProps
          RichText: { additionalComponentProps: narrowTextProps }
        }}
        additionalItemProps={{
          PageLinksBlock: { size: ContentAreaItem_Size.FullScreen }
        }}
        {...content}
      />
    </ContentContainer>
  </div>
);

Frontpage.displayName = 'Frontpage';

export default Frontpage;
